import router, { defaultTitle } from './router'
import store from '@/store'

router.beforeEach((to, from, next) => {
  // auth required routes
  if (to.matched.some(record => record.meta && record.meta.requiresAuth)) {
    store.dispatch('user/checkIfAuth')
      .then(isAuth => !isAuth && router.push({
        name: 'home',
        query: { login: true, redirect: to.fullPath }
      }))
  }

  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle)
    document.title = nearestWithTitle.meta.title
  else
    document.title = defaultTitle

  next()
})



// WEBPACK FOOTER //
// ./src/router/guards.js